import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseHttpService } from '@core/http/base-http.service';
import { TenantLanguageInterface } from '@shared/interfaces/tenant-language.interface';

@Injectable({
  providedIn: 'root',
})
export class TenantLanguageService extends BaseHttpService<TenantLanguageInterface> {
  constructor(protected http: HttpClient) {
    super(http);
  }

  getApiRootPath(): string {
    return 'tenant-languages';
  }
}
